import { Box } from '@mui/material'
import { FC } from 'react'

const Tc: FC<TcProps> = (props) => {
  const { data } = props

  return (
    <Box
      component="article"
      typography="body1"
      sx={{
        '& > *': { marginBlockEnd: '1em' },
      }}
    >
      {data.task_data.map(renderLine)}
    </Box>
  )
}

const renderLine = (line: TcProps['data']['task_data'][number]) => {
  const Tag = tags[line.element] || 'p'
  return (
    <Tag key={line.id} dangerouslySetInnerHTML={{ __html: line.content }} />
  )
}

const tags = {
  Header: 'h1',
  'Header Text': 'h1',
  Paragraph: 'p',
} as const

type TcProps = {
  data: Dto.Tc
}

export { Tc }
export type { TcProps }
